import * as React from "react";
import { styled } from "@mui/material/styles";
import { Box, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

const CssTextField = styled(TextField)({
	"& .MuiInputBase-root": {},
	"& input": {
		color: "white",
	},
	"& textarea": {
		color: "white",
	},
	"& label.Mui-focused": {
		color: "white",
	},
	"& label": {
		color: "white",
	},
	"& .MuiInput-underline:after": {
		borderBottomColor: "white",
	},
	"& .MuiOutlinedInput-root": {
		borderRadius: 10,
		"& fieldset": {
			borderWidth: 2,
			borderColor: "white",
		},
		"&:hover fieldset": {
			borderWidth: 3,
			borderColor: "white",
		},
		"&.Mui-focused fieldset": {
			borderWidth: 3,
			borderColor: "white",
		},
	},
});

export default function CustomTextField({ errors, label, name, type, register, size, light, adornment, endAdornment, mt, ...rest }) {
	return (
		<Box mt={mt} style={{ width: "100%" }}>
			{light ? (
				<CssTextField
					error={Boolean(errors)}
					helperText={errors?.message}
					fullWidth
					label={label}
					name={name}
					type={type}
					variant="outlined"
					{...register(name)}
					{...rest}
				/>
			) : (
				<CssTextField
					error={Boolean(errors)}
					helperText={errors?.message}
					fullWidth
					label={label}
					name={name}
					type={type}
					size={size === "small" ? "small" : "medium"}
					variant="outlined"
					InputProps={{
						startAdornment: adornment,
						endAdornment: endAdornment,
					}}
					{...register(name)}
					{...rest}
				/>
			)}
		</Box>
	);
}
